import React from "react";

const LogoWithTitle = ({src, title, ...props}) => {
    return (
        <div className="sm:mx-auto sm:w-full uppercase sm:max-w-sm">
            <img
                alt="Your Company"
                src={src}
                className="mx-auto h-20 w-auto"
            />
            <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
                {title}
            </h2>
        </div>
    );
}
export default LogoWithTitle;